import { EventEmitter } from '@angular/core';

import { DynamicFormDesignerComponent } from '../dynamic-form-designer.component';

export abstract class AbstractToolService {
  completed: EventEmitter<any> = new EventEmitter();

  designer: DynamicFormDesignerComponent;

  constructor() {}

  abstract do(host: any, args: any): void;

  raiseCompletedEvent(args: any) {
    this.completed.emit(args);
  }
}
